export default __webpack_public_path__ + "static/media/play_video_button_normal.3a313bdb.svg";